import { render, staticRenderFns } from "./ListMarketplaceFee.vue?vue&type=template&id=0f30cd74&"
import script from "./ListMarketplaceFee.vue?vue&type=script&lang=js&"
export * from "./ListMarketplaceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports